// export const BASE_URL_API = 'https://cors-anywhere.herokuapp.com/https://stylelink.in/andromeda/web/apis';
export const BASE_URL_API = 'https://stylelink.in/andromeda/web/apis';
export const STYLELINK_LOGO_URL = 'https://d26wg3m90fktzo.cloudfront.net/uploads/001721807041000002/1761386600402-logo-stylelink-small-pink.png';
